var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ThemeModuleExtensionLoader = void 0;
    class ThemeModuleExtension {
        constructor(application, config) {
            this.application = application;
            this.config = config;
            this.loadThemeModules();
        }
        loadThemeModules() {
            const containerEl = this.application.options.containerEl;
        }
        activate() {
        }
        deactivate() {
        }
        preloadAppFragments(application) {
            return __awaiter(this, void 0, void 0, function* () {
                // TODO: let us refactor that into a uniform api.
                var appFragmentStore = application.getAppFragmentStore();
                return new Promise((resolve, reject) => {
                    const promise = appFragmentStore === null || appFragmentStore === void 0 ? void 0 : appFragmentStore.getAllAppDescriptions(undefined, { application });
                    if (!promise) {
                        reject('');
                    }
                    else {
                        promise.then(allAppFragments => {
                            const themeAppfragments = allAppFragments.filter(appFragment => appFragment && appFragment.type === 'theme' && appFragment.name == (this.config.themeName || "default"));
                            resolve(themeAppfragments);
                        });
                    }
                });
            });
        }
        loadClientComponentAsync(name, parentLoader) {
            return __awaiter(this, void 0, void 0, function* () {
                return yield parentLoader;
            });
        }
        unload() {
        }
    }
    class ThemeModuleExtensionLoader {
        load(application, config) {
            return new ThemeModuleExtension(application, config);
        }
    }
    exports.ThemeModuleExtensionLoader = ThemeModuleExtensionLoader;
});
